import { GET_SECTORS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_SECTORS] (state, sectors) {
    state.all = sectors
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sectors.js